// Background Carousel

new window.Swiper("#homeHeroBgCarousel", {
	slidesPerView: 1,
	autoplay: {
		delay: 6000,
	},
});

new window.Swiper("#homeHeroWidgetCarousel", {
	slidesPerView: 1,
	spaceBetween: 20,
	autoHeight: true,
	pagination: {
		el: ".widget-carousel-pagination",
		type: "bullets",
		clickable: true,
	},
});
